import {
  employeeCompanies,
  employeeInsurance,
  policityInsuranceCompany,
  getMassiveExclusionTickets,
  TicketqueryParamsBaja,
  postTicketBajaIndividual,
  finishTicketBaja,
  cancelTicketBaja,
  employeeService,
  policyHolderExclusionService,
  ticketGroupService,
  updateEndDateBeforeFinishExclusion
} from '../../../network';

import {
  SET_COMPANY_BY_RUT,
  FETCH_COMPANY_BY_RUT,
  GET_COMPANY_BY_RUT,
  SET_INSURANCE_COMPANY_BY_RUT,
  FETCH_INSURANCECOMPANY_BY_RUT,
  SET_POLICY_INSURANCE_COMPANY,
  FETCH_POLICY_INSURANCE_COMPANY,
  POST_TICKET_MASSIVE_EXCLUSION,
  GET_BAJA_MASIVA,
  SET_BAJA_MASIVA,
  FETCH_BAJA_MASIVA,
  SET_BAJA_INDIVIDUAL,
  FETCH_BAJA_INDIVIDUAL,
  GET_BAJA_INDIVIDUAL,
  CANCEL_MASSIVE_EXCLUSION,
  PRESUCCESS_MASSIVE_EXCLUSION,
  SUCCESS_MASSIVE_EXCLUSION,
  FETCH_BM_URL,
  POST_INDIVIDUAL_EXCLUSION,
  PATCH_FINISH_EXCLUSION_TICKET,
  POST_CANCEL_EXCLUSION_TICKET,
  UPDATE_END_DATE_BEFORE_FINISH_EXCLUSION,
  UPDATE_END_DATE_BEFORE_FINISH_MASSIVE_EXCLUSION,
  POST_V2_POLICY_HOLDER_EXCLUSION,
  FETCH_V2_POLICY_HOLDER_TICKET,
  FETCH_V2_POLICY_HOLDER_EXCLUSIONS,
  PATCH_V2_POLICY_HOLDER_EXCLUSION,
  PATCH_V2_POLICY_HOLDER_EXCLUSIONS,
  PATCH_V2_POLICY_HOLDER_STATUS,
  FETCH_V2_EMPLOYEE_COVERAGES,
  FETCH_V2_EMPLOYEE_COVERAGES_WITH_DEPENDENTS
} from './types';

const store = {};

const getDefaultState = () => ({
  companyByRut: [],
  insuranceCompanyByRut: [],
  policyInsuranceCompany: [],
  companies: [],
  bajaMasiva: [],
  bajaIndividual: [],
  url: ''
});

store.state = getDefaultState();

store.getters = {
  [GET_COMPANY_BY_RUT]: (state) => state.companyByRut,
  [GET_BAJA_MASIVA]: (state) => state.bajaMasiva,
  [GET_BAJA_INDIVIDUAL]: (state) => state.bajaIndividual
};

// * Mutations
store.mutations = {
  [SET_COMPANY_BY_RUT](state, payload) {
    state.companyByRut = payload;
  },
  [SET_INSURANCE_COMPANY_BY_RUT](state, payload) {
    state.insuranceCompanyByRut = payload;
  },
  [SET_POLICY_INSURANCE_COMPANY](state, payload) {
    state.policyInsuranceCompany = payload;
  },
  [SET_BAJA_INDIVIDUAL](state, payload) {
    state.bajaIndividual = payload.map((a) => {
      return {
        id: a.id,
        key: a.id,
        holding: a.company?.holding
          ? a.company?.holding.businessName
          : a.company.subHolding?.holding?.businessName,
        subholding: a
          ? a.company.subHolding
            ? a.company.subHolding.name
            : ''
          : '',
        companyName: a.company.businessName,
        companyRut: a.company.rut,
        employeeName: `${a.employee.firstName} ${a.employee.firstSurname}`,
        employeeRut: a.employee.rut,
        ticketState: a.states.sort((a, b) => {
          return b.id - a.id;
        })[0].state.id,
        createdAt: a.createdAt,
        detail: 'Ver más',
        states: a.states
      };
    });
  },
  [SET_BAJA_MASIVA](state, payload) {
    state.bajaMasiva = payload.map((a) => {
      return {
        id: a.id,
        key: a.id,
        holding: a.holding ? a.holding : '',
        subholding: a.subHolding ? a.subHolding : '',
        companyName: a.businessName,
        companyRut: a.companyRut,
        count: a.count,
        createdAt: a.createdAt,
        detail: 'Ver más'
      };
    });
  }
};

// * Actions
store.actions = {
  [FETCH_BM_URL](_, { companyId, insuranceCompanyId } = {}) {
    return ticketGroupService.getMassiveExclusionFormatUrl(
      companyId,
      insuranceCompanyId
    );
  },
  [FETCH_COMPANY_BY_RUT]({ commit }, payload) {
    return new Promise((resolve, reject) => {
      employeeCompanies(payload).then(
        (resp) => {
          commit(SET_COMPANY_BY_RUT, resp);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  [FETCH_INSURANCECOMPANY_BY_RUT]({ commit }, { payload, companyId }) {
    return new Promise((resolve, reject) => {
      employeeInsurance(payload, companyId).then(
        (resp) => {
          commit(SET_INSURANCE_COMPANY_BY_RUT, resp.data);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  [FETCH_POLICY_INSURANCE_COMPANY]({ commit }, { company, insurance, rut }) {
    return new Promise((resolve, reject) => {
      policityInsuranceCompany(company, insurance, rut).then(
        (resp) => {
          commit(SET_POLICY_INSURANCE_COMPANY, resp.data);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  async [POST_TICKET_MASSIVE_EXCLUSION](_, payload) {
    const formData = new FormData();
    formData.append('insuranceCompanyId', payload.insurance);
    formData.append('companyId', payload.company);
    formData.append('brokerId', payload.brokerId);
    formData.append('message', payload.message);
    formData.append('file', payload.fileList[0]);
    payload.optionalFiles.forEach((f) => {
      formData.append('optionalFiles', f);
    });
    payload.policyId.forEach((p) => {
      formData.append('policies[]', p);
    });
    let error = '';
    const response = await ticketGroupService
      .createMassiveExclusion(formData)
      .catch((err) => (error = err));
    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    }
    if (response?.ticketId || response?.successTickets) return response;
    throw error;
  },
  async [FETCH_BAJA_MASIVA]({ commit }) {
    let error = '';
    const response = await getMassiveExclusionTickets().catch(
      (err) => (error = err)
    );
    if (response && response.status === 200) {
      commit(SET_BAJA_MASIVA, response.data);
    } else {
      throw error;
    }
  },
  async [FETCH_BAJA_INDIVIDUAL]({ commit }) {
    return new Promise((resolve, reject) => {
      TicketqueryParamsBaja().then(
        (resp) => {
          commit(SET_BAJA_INDIVIDUAL, resp.data);
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  [POST_INDIVIDUAL_EXCLUSION](_, payload) {
    return new Promise((resolve, reject) => {
      postTicketBajaIndividual(payload).then(
        (resp) => {
          resolve(resp);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  async [PRESUCCESS_MASSIVE_EXCLUSION](_, ticketGroupId) {
    return ticketGroupService.preSuccessMassiveExclusion(ticketGroupId);
  },
  async [CANCEL_MASSIVE_EXCLUSION](_, { payload, idAlta }) {
    const formData = new FormData();
    formData.append('message', payload.message);
    formData.append(
      'ticketCancels',
      JSON.stringify(payload.ticketCancels || [])
    );
    formData.append('file', payload.fileList[0]);
    let error = '';
    const response = await ticketGroupService
      .cancelMassiveExclusion(idAlta, formData)
      .catch((err) => (error = err));
    if (response && (response.status === 200 || response.status === 201)) {
      return response.data;
    }
    if (response?.ticketCancels) return response;
    throw error;
  },

  async [SUCCESS_MASSIVE_EXCLUSION](_, { idAlta, payload }) {
    let error = '';
    const response = await ticketGroupService
      .successMassiveExclusion(idAlta, payload)
      .catch((err) => (error = err));
    if (response && (response.status === 201 || response.status === 200)) {
      return response;
    }
    if (response?.successTickets) return response;
    throw error;
  },
  [PATCH_FINISH_EXCLUSION_TICKET](_, payload) {
    return new Promise((resolve, reject) => {
      finishTicketBaja(payload)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [POST_CANCEL_EXCLUSION_TICKET](_, payload) {
    return new Promise((resolve, reject) => {
      cancelTicketBaja(payload)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async [UPDATE_END_DATE_BEFORE_FINISH_EXCLUSION](_, { id, endDate }) {
    const response = await updateEndDateBeforeFinishExclusion(id, endDate);
    return response.data;
  },
  async [UPDATE_END_DATE_BEFORE_FINISH_MASSIVE_EXCLUSION](
    _,
    { ticketId, endDate }
  ) {
    return ticketGroupService.updateMassiveExclusionEndDate(ticketId, endDate);
  },
  async [FETCH_V2_EMPLOYEE_COVERAGES](_, { employeeId, params } = {}) {
    return employeeService.getActiveCoverages(employeeId, params);
  },
  async [FETCH_V2_EMPLOYEE_COVERAGES_WITH_DEPENDENTS](_, { employeeId } = {}) {
    return employeeService.getActiveCoveragesWithDependents(employeeId);
  },
  async [POST_V2_POLICY_HOLDER_EXCLUSION](_, payload) {
    const formData = new FormData();
    formData.append('companyId', payload.companyId);
    formData.append('brokerId', payload.brokerId);
    formData.append('insuranceCompanyId', payload.insuranceCompanyId);
    formData.append('employeeId', payload.employeeId);
    formData.append('endDate', payload.endDate);
    if (payload.message !== undefined && payload.message !== null) {
      formData.append('message', payload.message);
    }
    payload.exclusions.forEach((exclusion, index) => {
      formData.append(
        `exclusions[${index}][employeeCoverageId]`,
        exclusion.employeeCoverageId
      );
      if (exclusion.endDate) {
        formData.append(`exclusions[${index}][endDate]`, exclusion.endDate);
      }
    });
    (payload.optionalFiles || []).forEach((file) => {
      formData.append('optionalFile', file);
    });
    return policyHolderExclusionService.create(formData);
  },
  async [FETCH_V2_POLICY_HOLDER_TICKET](_, ticketId) {
    return policyHolderExclusionService.getTicket(ticketId);
  },
  async [FETCH_V2_POLICY_HOLDER_EXCLUSIONS](_, ticketId) {
    return policyHolderExclusionService.getExclusions(ticketId);
  },
  async [PATCH_V2_POLICY_HOLDER_EXCLUSION](
    _,
    { ticketId, exclusionId, endDate }
  ) {
    return policyHolderExclusionService.updateExclusion(ticketId, exclusionId, {
      endDate
    });
  },
  async [PATCH_V2_POLICY_HOLDER_EXCLUSIONS](_, { ticketId, endDate }) {
    return policyHolderExclusionService.updateExclusions(ticketId, {
      endDate
    });
  },
  async [PATCH_V2_POLICY_HOLDER_STATUS](_, { ticketId, status }) {
    return policyHolderExclusionService.patchStatus(ticketId, status);
  }
};

export default store;
